// Client-side counterpart of the server's HqlSearch.likeAllWords: a multi-word "all words must match"
// matcher. Splits the query on whitespace and requires every word to appear (as a substring) somewhere
// across the given fields — so searching "Rama priya" matches "Rama fdsk fdsklfd s priya", order-independent.
// A single word behaves like a plain "contains". Used by the Combobox typeahead and the shop browse filter.
// Devotee names carry diacritics (Śrī, Rāma, Ṭhākura…) while people type plain ASCII — fold BOTH
// sides so "sri rama" matches "Śrī Rāma dāsa". NFD splits base letters from their combining marks;
// stripping the combining-mark range (U+0300–U+036F) leaves the plain base letters.
export function fold(s: string): string {
  return s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}

export function matchesAllWords(query: string | null | undefined, ...fields: (string | null | undefined)[]): boolean {
  const q = fold((query ?? "").trim());
  if (!q) return true;
  const haystack = fold(fields.filter(Boolean).join(" "));
  return q.split(/\s+/).every((w) => haystack.includes(w));
}
